STUDIP.domReady(function () {
    STUDIP.Dialog.initialize();
});
